/** Crown (CAB Payments) wallets on the Bank Payments Balances tab, and incoming-funds alerts. */
import { api, type BpBalance } from "@/lib/api";

export interface CrownIncoming {
  id: number; walletId: string; currency: string; amount: number;
  previousBalance: number | null; newBalance: number | null;
  sfAccountId: string | null; sfAccountName: string | null; sfBankAccountName: string | null;
  detectedAt: string | null;
}
export interface CrownStatus {
  configured: boolean; missing: string[]; lastOkAt: string | null;
  lastError: string | null; lastErrorAt: string | null; wallets: number | null; pollSeconds: number;
}
export interface CrownWallet {
  balance: BpBalance | null; incoming: CrownIncoming[]; subscribed: boolean; status: CrownStatus; now: string;
}
export interface CrownSub { walletId: string; currency: string }

export const crownApi = {
  wallet: (walletId: string, currency: string) =>
    api.client.get("/bank-payments/crown/wallet", { params: { walletId, currency } }).then((r) => r.data as CrownWallet),
  refresh: () => api.client.post("/bank-payments/crown/refresh", undefined, { timeout: 90_000 }).then((r) => r.data),
  subscriptions: () =>
    api.client.get("/bank-payments/crown/alerts").then((r) => r.data.subscriptions as CrownSub[]),
  setAlert: (walletId: string, currency: string, on: boolean) =>
    api.client.post("/bank-payments/crown/alerts", { walletId, currency, on })
      .then((r) => r.data as { subscribed: boolean; subscriptions: CrownSub[] }),
  incoming: (since: number | null) =>
    api.client.get("/bank-payments/crown/incoming", { params: since == null ? {} : { since } })
      .then((r) => r.data as { events: CrownIncoming[]; latestId: number }),
};
